import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface';
import { MACCFilterConfig } from './filters/MACCFilterConfig';
import { MACCConstants } from 'src/Common/Models/MaccConst';
const urlParams = new URLSearchParams(new URL(window.location.href).search);
const workItemId = urlParams.get('id');
export const MACCTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.MACCException],
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: MACCFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: MACCFilterConfig,
      AreaPath: [UATConstants.McapsMaccAreaPath],
      Title: UATConstants.TenantTitles.MACC,
      ADOTitle: UATConstants.TenantADOText.MACC,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateMaccSupportRequest,
          Key: UATConstants.CreateActionMenuKey.CreateMaccSupportRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'macc',
        title: UATConstants.PlaceholdersAndTitles.MACC,
        excelColumnSequence: {
          'Title': 1,
          'Assigned Team': 2,
          'Action Owner': 3,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedTo', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'requestor', formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestors, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'MACC_AEAlias', formFieldLabel: MACCConstants.PlaceholdersAndTitles.AEName, apiFieldName: 'macc_ae_alias' },
        { formFieldName: 'MACC_Requestor_Manager', formFieldLabel: MACCConstants.PlaceholdersAndTitles.RequestorManager, apiFieldName: 'macc_requestor_manager' },
        { formFieldName: 'MACC_Exception_Approver', formFieldLabel: MACCConstants.PlaceholdersAndTitles.ExceptionApprover, apiFieldName: 'macc_exception_approver' },
        { formFieldName: 'MACC_CEAlias', formFieldLabel: MACCConstants.PlaceholdersAndTitles.CEName, apiFieldName: 'macc_ce_alias' },
        { formFieldName: 'MACC_SSSPAlias', formFieldLabel: MACCConstants.PlaceholdersAndTitles.SSSPName, apiFieldName: 'macc_sssp_alias' },
        { formFieldName: 'MACC_Notification_tobe_sent', formFieldLabel: MACCConstants.PlaceholdersAndTitles.MACCNotificationsent, apiFieldName: 'stakeholdersinfo' },
        { formFieldName: 'MACC_Optional_Area_Support_Lead', formFieldLabel: MACCConstants.PlaceholdersAndTitles.MACCOptionalAreaSupportLead, apiFieldName: 'macc_optionalareasupportlead' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      systemViewsFolderId: '830e58ca-ff82-45bd-879b-913147e4e632',
      sharedViewsFolderId: '4faaf147-ac67-4756-aa0e-63a96a9b047e',
    },
  },
};
